import { makeStyles } from "@tiny/components";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    padding: "12px 0",
  },
  body: {
    flex: "1",
  },
  name: {
    display: "inline-block",
    maxWidth: "400px",
    marginRight: 8,
    verticalAlign: "middle",
  },
  action: {
    flex: "0 0 36px",
  },
  icon: {
    "& svg": {
      width: 20,
      height: 20,
      color: theme.palette.grey[600],
    },
  },
}));
